import React from "react";
import {NavLink} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';
import {Edit} from '../../utils/svgs';

import UserContext from '../../utils/UserContext';
import {PERMISSIONS} from '../../utils/Request';


class pageListProductsToBuy extends pageList {
	
	constructor(props){
		super(props)
		this.apiName = 'products-to-buy';
		this.listSlug = 'productos';
		this.singleItem = 'producto'; //Name of a single list item
		this.listTitle = 'Productos a comprar';
		this.responseField = 'products';

		// this.hasRowOptions = false;
		this.listWithoutLinks = true;

		this.notifyProducts = this.notifyProducts.bind(this);
	}
	
	componentDidMount(){
		this.requestPages();
	}

	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'brand',
				name: 'Brand',
				class: 'item-medium',
				canSearch: true,
			},
			// {
			// 	slug: 'name',
			// 	name: 'Nombre',
			// 	class: 'item-big',
			// 	canSearch: true,
			// },
			{
				slug: 'sku',
				name: 'SKU',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'provider',
				name: 'Proveedor',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'sku_provider',
				name: 'SKU Proveedor',
				class: 'item-medium',
			},
			{
				slug: 'stock',
				name: 'Stock',
				class: 'item-medium',
				canSort: true,
			},
			{
				slug: 'stock_almacen',
				name: 'Stock almacen',
				class: 'item-medium',
				canSort: true,
			},
			{
				slug: 'low_stock_amount',
				name: 'Stock mínimo',
				class: 'item-medium',
				canSort: true,
			},
			{
				slug: 'max_stock_amount',
				name: 'Stock máximo',
				class: 'item-medium',
				canSort: true,
			},
			{
				slug: 'units_to_buy',
				name: 'Unidades a comprar',
				class: 'item-medium',
				canSort: true,
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		return {
			item : page,
			brand : page.brand,
			sku : page.sku,
			name : page.name,
			sku_soultek : page.sku_soultek,
			sku_stk : page.sku_stk,
			provider : page.provider,
			sku_provider : page.sku_provider,
			location_store: page.location_store,
			bar_code: page.bar_code,
			stock : page.stock,
			stock_almacen : page.stock_almacen,
			low_stock_amount : page.low_stock_amount,
			max_stock_amount : page.max_stock_amount,
			units_to_buy : page.units_to_buy
		};
	}

	notifyProducts(){
		if(!this.sendingEmail){
			this.sendingEmail = true;
			Request.postAuth('/api/products-to-buy/notify')
				.then(json => {
					alert("Se está enviando el email");
					this.sendingEmail = false;
			});
		}
	}


	renderAddNew(){
		return <React.Fragment>
			<UserContext.Consumer>
				{user => {
					if(PERMISSIONS.canAdministrator(user)){
						return (
							<button className="button button-default font-p font-white font-center" onClick={this.notifyProducts}>Enviar email</button>
						)
					}
				}}
			</UserContext.Consumer>
		</React.Fragment>
	}

	renderDeleteIcon(row, index){
		return (
			<div onClick={()=>window.location='/productos/'+row.item.id} title="Ver Producto" className="icon-container font-right">
				<Edit/>
			</div>
		);
	}

	
}





export default pageListProductsToBuy;




